/**
 * Task Details Time Off field Names
 * @type {Readonly<{id: string, assignmentNumber: string, startDate: string, endDate: string, hoursType: string, rqstHours: string, finalStatus: string}>}
 */
const taskDetailsTimeOffFieldName = Object.freeze({
  id: "id",
  assignmentNumber: "assignmentNumber",
  startDate: "startDate",
  endDate: "endDate",
  hoursType: "hoursType",
  rqstHours: "rqstHours",
  finalStatus: "finalStatus"
});

/**
 *  Task Details Time Off field Text
 * @type {Readonly<{id: string, assignmentNumber: string, startDate: string, endDate: string, hoursType: string, rqstHours: string, finalStatus: string}>}
 */
const taskDetailsTimeOffFieldText = Object.freeze({
  id: "ID",
  assignmentNumber: "Assignment Number",
  startDate: "Start Date",
  endDate: "End Date",
  hoursType: "Hours Type",
  rqstHours: "Requested Hours",
  finalStatus: "Final Status"
});

export { taskDetailsTimeOffFieldName, taskDetailsTimeOffFieldText };
